import { useRouter } from 'next/router';

export const useMultiplexBuildingSessionId = () => {
  const router = useRouter();

  return { multiplexBuildingSessionId: router.query.multiplexBuildingSessionId as string | undefined };
};
